module.exports = __webpack_public_path__ + "img/icon-flag-ro.e9130a28.svg";